import BigNumber from 'bignumber.js';

import { IPFS_PREFIX, TOKENS_YEAR } from 'modules/api/const';
import { HUNDRED, ONE } from 'modules/common/const';

interface ICalculateAPYParams {
  totalStakedAmount: BigNumber;
  fee: BigNumber;
}

export function calculateAPY({
  totalStakedAmount,
  fee,
}: ICalculateAPYParams): BigNumber {
  return TOKENS_YEAR.div(2).multipliedBy(
    ONE.minus(fee.div(HUNDRED)).div(totalStakedAmount).multipliedBy(HUNDRED),
  );
}

export function getIPFSHash(withPrefixLink: string): string {
  return withPrefixLink.startsWith(IPFS_PREFIX)
    ? withPrefixLink.replace(IPFS_PREFIX, '')
    : withPrefixLink;
}
